import { Alert, Snackbar, Typography } from '@mui/material';
import React, { useContext } from 'react';
import './SnackbarAlert.css';
import { SnackbarContext } from '../snackbar/Snackbar';

const SnackbarAlert = () => {
    const { open, severity, title, message, errors, duration, closeSnackbar } = useContext(SnackbarContext);

    return (
        <Snackbar
            open={open}
            autoHideDuration={duration}
            onClose={closeSnackbar}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            className='snackbar-container'
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
        >
            <Alert
                severity={severity || 'info'}
                onClose={closeSnackbar}
                className={errors?.length > 0 ? 'snackbar-alert-detailed' : undefined}
            >
                <Typography className='message-text'>
                    <strong>{title}</strong>
                    {message}
                </Typography>

                {errors?.length > 0 && (
                    <ul className='snackbar-error-list'>
                        {errors.map((error, index) => (
                            <li key={index} className='snackbar-error-item'>{error}</li>
                        ))}
                    </ul>
                )}
            </Alert>
        </Snackbar>
    )
}

export default SnackbarAlert